import { Component } from '@angular/core';
import { AdminSearchCriteria } from 'src/app/core/enums/admin-search-criteria.enum';
import { DISPLAY_TEXT } from './admin-search.constants';

@Component({
  selector: 'app-admin-search',
  templateUrl: './admin-search.component.html',
  standalone: false,
})
export class AdminSearchComponent {
  readonly CONSTANTS = DISPLAY_TEXT;
  readonly filter = AdminSearchCriteria;
  selectedFilter = AdminSearchCriteria.LOCATIONADMIN;

  radioGroupValue(event: Event) {
    this.selectedFilter = (event?.target as HTMLElement)
      ?.id as AdminSearchCriteria;
  }
}
